module.exports = __webpack_public_path__ + "img/comochegar.34693f75.jpg";